module.exports = "/_next/static/images/logo-dark-en-b0823e8efb34696b541a3da17f4d96aa.png";